import { h, FunctionComponent } from 'preact'

export const FirefoxIcon: FunctionComponent = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5983_4369)">
        <path
          d="M18.9802 6.71496C18.5589 5.70138 17.7044 4.60701 17.0353 4.26106C17.5125 5.18506 17.8437 6.17737 18.0171 7.20273L18.0189 7.21899C16.9228 4.48744 15.0647 3.38431 13.5463 0.985444C13.4695 0.864125 13.3927 0.742555 13.3179 0.614232C13.2752 0.540941 13.2409 0.474903 13.2111 0.414118C13.1482 0.292187 13.0997 0.163327 13.0666 0.0301498C13.0666 0.0240044 13.0644 0.0180576 13.0603 0.013444C13.0563 0.00883044 13.0506 0.00587289 13.0445 0.00513558C13.0386 0.00349647 13.0323 0.00349647 13.0263 0.00513558C13.025 0.00513558 13.023 0.00738686 13.0215 0.00788714C13.02 0.00838743 13.0168 0.0106387 13.0145 0.0116393L13.0183 0.00513558C10.5831 1.43095 9.75642 4.06995 9.68138 5.3907C8.70856 5.4574 7.77844 5.81576 7.01236 6.41904C6.93246 6.35136 6.84896 6.28807 6.76221 6.22943C6.54134 5.45622 6.53192 4.63792 6.73495 3.85983C5.84066 4.29303 5.04603 4.90716 4.40137 5.66336H4.39687C4.01265 5.17633 4.03966 3.57042 4.06168 3.23497C3.94801 3.28066 3.83951 3.33826 3.73799 3.40682C3.39881 3.6489 3.08172 3.92053 2.79045 4.21853C2.45854 4.55505 2.15539 4.91878 1.88419 5.3059V5.3074V5.30565C1.26097 6.18906 0.81888 7.18715 0.583447 8.24233L0.570439 8.30636C0.552179 8.39166 0.486391 8.8189 0.475135 8.91171C0.475135 8.91896 0.473634 8.92571 0.472884 8.93297C0.388022 9.37406 0.335437 9.82074 0.315544 10.2695V10.3195C0.319829 12.7455 1.23346 15.0818 2.87609 16.8671C4.51872 18.6524 6.77097 19.757 9.18824 19.9629C11.6055 20.1688 14.0121 19.461 15.933 17.9792C17.8539 16.4974 19.1495 14.3493 19.564 11.9589C19.5803 11.8339 19.5935 11.71 19.608 11.5837C19.8077 9.93326 19.5915 8.25906 18.9792 6.71346L18.9802 6.71496ZM7.80631 14.3043C7.85159 14.326 7.89411 14.3496 7.94064 14.3703L7.94739 14.3746C7.90036 14.3521 7.85334 14.3286 7.80631 14.3043ZM18.0191 7.22174V7.21249L18.0209 7.22275L18.0191 7.22174Z"
          fill="url(#paint0_linear_5983_4369)"
        />
        <path
          d="M18.9801 6.71562C18.5589 5.70204 17.7044 4.60767 17.0353 4.26172C17.5124 5.18572 17.8436 6.17803 18.0171 7.20339V7.21265L18.0188 7.2229C18.7662 9.36139 18.6581 11.706 17.7172 13.7666C16.606 16.1507 13.9175 18.5944 9.70759 18.4743C5.16 18.3455 1.15272 14.9698 0.404797 10.5498C0.268469 9.85265 0.404797 9.4992 0.473336 8.93263C0.379845 9.37272 0.327672 9.82059 0.317497 10.2704V10.3204C0.321782 12.7464 1.23542 15.0827 2.87804 16.868C4.52067 18.6533 6.77292 19.758 9.19019 19.9638C11.6075 20.1697 14.0141 19.4619 15.935 17.9801C17.8559 16.4983 19.1515 14.3502 19.566 11.9599C19.5822 11.8348 19.5955 11.711 19.61 11.5846C19.8097 9.93417 19.5935 8.25997 18.9811 6.71437L18.9801 6.71562Z"
          fill="url(#paint1_radial_5983_4369)"
        />
        <path
          d="M18.9801 6.71562C18.5589 5.70204 17.7044 4.60767 17.0353 4.26172C17.5124 5.18572 17.8436 6.17803 18.0171 7.20339V7.21265L18.0188 7.2229C18.7662 9.36139 18.6581 11.706 17.7172 13.7666C16.606 16.1507 13.9175 18.5944 9.70759 18.4743C5.16 18.3455 1.15272 14.9698 0.404797 10.5498C0.268469 9.85265 0.404797 9.4992 0.473336 8.93263C0.379845 9.37272 0.327672 9.82059 0.317497 10.2704V10.3204C0.321782 12.7464 1.23542 15.0827 2.87804 16.868C4.52067 18.6533 6.77292 19.758 9.19019 19.9638C11.6075 20.1697 14.0141 19.4619 15.935 17.9801C17.8559 16.4983 19.1515 14.3502 19.566 11.9599C19.5822 11.8348 19.5955 11.711 19.61 11.5846C19.8097 9.93417 19.5935 8.25997 18.9811 6.71437L18.9801 6.71562Z"
          fill="url(#paint2_radial_5983_4369)"
        />
        <path
          d="M14.2669 7.85338C14.2879 7.86813 14.3075 7.88289 14.3272 7.89765C14.0837 7.46583 13.7805 7.07047 13.4267 6.72323C10.4125 3.70902 12.637 0.189512 13.012 0.00940938L13.0157 0.00390625C10.5806 1.42972 9.75387 4.06872 9.67883 5.38947C9.79189 5.38172 9.90395 5.37221 10.0195 5.37221C10.8835 5.37388 11.7316 5.60429 12.4776 6.04001C13.2237 6.47572 13.841 7.10121 14.2669 7.85288V7.85338Z"
          fill="url(#paint3_radial_5983_4369)"
        />
        <path
          d="M10.0256 8.4556C10.0096 8.69674 9.15763 9.52846 8.85971 9.52846C6.10314 9.52846 5.65539 11.1962 5.65539 11.1962C5.77746 12.6005 6.75601 13.7576 7.93894 14.368C7.99297 14.396 8.04775 14.4212 8.10253 14.446C8.19742 14.488 8.29231 14.5269 8.38719 14.5626C8.79317 14.7062 9.21838 14.7883 9.64866 14.806C14.4814 15.0326 15.4169 9.02768 11.9297 7.28418C12.7523 7.17715 13.5854 7.37941 14.2673 7.85176C13.8414 7.10009 13.224 6.4746 12.478 6.03889C11.7319 5.60317 10.8838 5.37277 10.0199 5.37109C9.90481 5.37109 9.79224 5.3806 9.67918 5.38835C8.70636 5.45505 7.77624 5.81341 7.01016 6.41669C7.15799 6.54176 7.32484 6.70886 7.67629 7.0553C8.33416 7.70342 10.0214 8.3748 10.0251 8.4536L10.0256 8.4556Z"
          fill="url(#paint4_radial_5983_4369)"
        />
        <path
          d="M10.0256 8.4556C10.0096 8.69674 9.15763 9.52846 8.85971 9.52846C6.10314 9.52846 5.65539 11.1962 5.65539 11.1962C5.77746 12.6005 6.75601 13.7576 7.93894 14.368C7.99297 14.396 8.04775 14.4212 8.10253 14.446C8.19742 14.488 8.29231 14.5269 8.38719 14.5626C8.79317 14.7062 9.21838 14.7883 9.64866 14.806C14.4814 15.0326 15.4169 9.02768 11.9297 7.28418C12.7523 7.17715 13.5854 7.37941 14.2673 7.85176C13.8414 7.10009 13.224 6.4746 12.478 6.03889C11.7319 5.60317 10.8838 5.37277 10.0199 5.37109C9.90481 5.37109 9.79224 5.3806 9.67918 5.38835C8.70636 5.45505 7.77624 5.81341 7.01016 6.41669C7.15799 6.54176 7.32484 6.70886 7.67629 7.0553C8.33416 7.70342 10.0214 8.3748 10.0251 8.4536L10.0256 8.4556Z"
          fill="url(#paint5_radial_5983_4369)"
        />
        <path
          d="M6.55831 6.09615C6.63685 6.14618 6.70164 6.1897 6.75842 6.22897C6.53754 5.45577 6.52813 4.63746 6.73115 3.85938C5.83686 4.29257 5.04223 4.9067 4.39758 5.6629C4.44485 5.66165 5.85115 5.63639 6.55831 6.09615Z"
          fill="url(#paint6_radial_5983_4369)"
        />
        <path
          d="M0.401436 10.5492C1.14961 14.9692 5.15664 18.3461 9.70423 18.4737C13.9141 18.5928 16.6032 16.1489 17.7138 13.766C18.6548 11.7054 18.7628 9.36078 18.0155 7.2223V7.21304C18.0155 7.20579 18.014 7.20154 18.0155 7.20379L18.0172 7.22005C18.3612 9.46558 17.219 11.6401 15.4332 13.1134L15.4277 13.1259C11.9483 15.96 8.61887 14.8354 7.94598 14.3766C7.89896 14.3541 7.85193 14.3307 7.8049 14.3063C5.7765 13.3368 4.93827 11.4897 5.11837 9.90383C4.63687 9.91093 4.16365 9.77825 3.75603 9.52185C3.34842 9.26545 3.0239 8.89635 2.82181 8.45925C3.35432 8.13306 3.96148 7.94865 4.58545 7.9236C5.20942 7.89855 5.82941 8.0337 6.38634 8.31617C7.53432 8.83725 8.84058 8.8886 10.0259 8.45925C10.0222 8.38046 8.33495 7.70883 7.67708 7.06096C7.32563 6.71451 7.15878 6.54767 7.01095 6.42234C6.93105 6.35467 6.84755 6.29138 6.76081 6.23274C6.70327 6.19346 6.63849 6.15094 6.56069 6.09991C5.85354 5.64015 4.44724 5.66541 4.40071 5.66666H4.39621C4.01199 5.17964 4.03901 3.57372 4.06102 3.23828C3.94735 3.28396 3.83885 3.34157 3.73734 3.41013C3.39815 3.6522 3.08106 3.92383 2.7898 4.22184C2.45669 4.55741 2.15229 4.92031 1.87978 5.30671C1.25656 6.19012 0.81447 7.18796 0.579037 8.24313C0.574284 8.26289 0.229838 9.76875 0.399685 10.5497L0.401436 10.5492Z"
          fill="url(#paint7_radial_5983_4369)"
        />
        <path
          d="M13.4278 6.72331C13.7817 7.07093 14.0849 7.46671 14.3283 7.89898C14.3816 7.93925 14.4314 7.97927 14.4736 8.01804C16.6716 10.0442 15.52 12.9083 15.4342 13.1109C17.2197 11.6399 18.3608 9.46387 18.0181 7.21759C16.9215 4.48353 15.0615 3.3804 13.5456 0.981537C13.4688 0.860218 13.392 0.738649 13.3172 0.610326C13.2744 0.537034 13.2402 0.470997 13.2104 0.410212C13.1474 0.288281 13.0989 0.159421 13.0658 0.0262436C13.0659 0.0200981 13.0637 0.0141514 13.0596 0.00953778C13.0555 0.00492419 13.0499 0.00196664 13.0438 0.00122933C13.0378 -0.000409775 13.0315 -0.000409775 13.0256 0.00122933C13.0243 0.00122933 13.0223 0.00348061 13.0208 0.00398089C13.0193 0.00448118 13.0161 0.00673246 13.0138 0.00773303C12.6388 0.185584 10.4148 3.70734 13.429 6.71905L13.4278 6.72331Z"
          fill="url(#paint8_radial_5983_4369)"
        />
        <path
          d="M14.4726 8.02062C14.4303 7.98185 14.3805 7.94183 14.3272 7.90155C14.3075 7.88679 14.288 7.87204 14.2669 7.85728C13.585 7.38494 12.752 7.18267 11.9294 7.28971C15.4163 9.0332 14.4808 15.0366 9.64831 14.8115C9.21803 14.7938 8.79282 14.7118 8.38685 14.5681C8.29196 14.5326 8.19707 14.4937 8.10218 14.4515C8.0474 14.4265 7.99262 14.4015 7.93859 14.3735L7.94534 14.3777C8.61923 14.8378 11.9476 15.9616 15.4271 13.127L15.4326 13.1145C15.5194 12.9119 16.6711 10.0478 14.4721 8.02162L14.4726 8.02062Z"
          fill="url(#paint9_radial_5983_4369)"
        />
        <path
          d="M5.65527 11.1971C5.65527 11.1971 6.10277 9.52943 8.85959 9.52943C9.15751 9.52943 10.0102 8.6977 10.0255 8.45657C8.84017 8.88591 7.53391 8.83456 6.38593 8.31348C5.829 8.03102 5.20901 7.89587 4.58504 7.92091C3.96107 7.94596 3.35391 8.13037 2.8214 8.45657C3.02349 8.89366 3.34801 9.26277 3.75562 9.51916C4.16324 9.77556 4.63646 9.90824 5.11796 9.90114C4.93836 11.4863 5.77634 13.3331 7.80449 14.3036C7.84977 14.3254 7.89229 14.3489 7.93882 14.3697C6.75489 13.7581 5.77734 12.6014 5.65527 11.1979V11.1971Z"
          fill="url(#paint10_radial_5983_4369)"
        />
        <path
          d="M18.9797 6.71496C18.5584 5.70138 17.7039 4.60701 17.0348 4.26106C17.512 5.18506 17.8432 6.17738 18.0166 7.20273L18.0184 7.21899C16.9223 4.48744 15.0642 3.38431 13.5458 0.985444C13.469 0.864125 13.3922 0.742556 13.3174 0.614232C13.2747 0.540941 13.2404 0.474903 13.2106 0.414118C13.1477 0.292187 13.0992 0.163327 13.0661 0.0301498C13.0661 0.0240044 13.0639 0.0180576 13.0598 0.013444C13.0558 0.00883044 13.0501 0.00587289 13.044 0.00513558C13.0381 0.00349647 13.0318 0.00349647 13.0258 0.00513558C13.0245 0.00513558 13.0225 0.00738686 13.021 0.00788714C13.0195 0.00838743 13.0163 0.0106387 13.014 0.0116393L13.0178 0.00513558C10.5826 1.43095 9.75592 4.06995 9.68088 5.3907C9.79394 5.38295 9.906 5.37344 10.0216 5.37344C10.8855 5.37511 11.7336 5.60552 12.4797 6.04123C13.2257 6.47695 13.8431 7.10244 14.269 7.85411C13.5871 7.38176 12.754 7.1795 11.9314 7.28653C15.4184 9.03003 14.4829 15.0334 9.65036 14.8083C9.22008 14.7906 8.79487 14.7086 8.38889 14.5649C8.294 14.5294 8.19912 14.4906 8.10423 14.4484C8.04945 14.4233 7.99467 14.3983 7.94064 14.3703L7.94739 14.3746C7.90036 14.3521 7.85334 14.3286 7.80631 14.3043C7.85158 14.326 7.89411 14.3496 7.94064 14.3703C6.75671 13.7585 5.77916 12.6018 5.65709 11.1985C5.65709 11.1985 6.10459 9.53081 8.86141 9.53081C9.15933 9.53081 10.0121 8.69909 10.0273 8.45795C10.0236 8.37915 8.33636 7.70752 7.67849 7.05965C7.32704 6.71321 7.16019 6.54636 7.01236 6.42104C6.93246 6.35337 6.84896 6.29007 6.76221 6.23143C6.54134 5.45822 6.53192 4.63992 6.73495 3.86183C5.84066 4.29503 5.04603 4.90916 4.40137 5.66536H4.39687C4.01265 5.17833 4.03966 3.57242 4.06168 3.23698C3.94801 3.28266 3.83951 3.34026 3.73799 3.40882C3.39881 3.6509 3.08172 3.92253 2.79045 4.22054C2.45854 4.55705 2.15539 4.92078 1.88419 5.30791C1.26097 6.19131 0.81888 7.18916 0.583447 8.24433L0.570439 8.30836C0.552179 8.39366 0.470382 8.82691 0.458626 8.91996C0.383808 9.36718 0.336028 9.81851 0.315544 10.2715V10.3215C0.319829 12.7475 1.23346 15.0838 2.87609 16.8691C4.51872 18.6544 6.77097 19.759 9.18824 19.9649C11.6055 20.1708 14.0121 19.463 15.933 17.9812C17.8539 16.4994 19.1495 14.3513 19.564 11.9609C19.5803 11.8359 19.5935 11.7121 19.608 11.5857C19.8077 9.93527 19.5915 8.26107 18.9792 6.71546L18.9797 6.71496Z"
          fill="url(#paint11_linear_5983_4369)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_5983_4369"
          x1="17.6969"
          y1="3.10188"
          x2="1.60203"
          y2="18.6307"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.048" stopColor="#FFF44F" />
          <stop offset="0.111" stopColor="#FFE847" />
          <stop offset="0.225" stopColor="#FFC830" />
          <stop offset="0.368" stopColor="#FF980E" />
          <stop offset="0.401" stopColor="#FF8B16" />
          <stop offset="0.462" stopColor="#FF672A" />
          <stop offset="0.534" stopColor="#FF3647" />
          <stop offset="0.705" stopColor="#E31587" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_5983_4369"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(17.074 2.25558) scale(20.2115)"
        >
          <stop offset="0.129" stopColor="#FFBD4F" />
          <stop offset="0.186" stopColor="#FFAC31" />
          <stop offset="0.247" stopColor="#FF9D17" />
          <stop offset="0.283" stopColor="#FF980E" />
          <stop offset="0.403" stopColor="#FF563B" />
          <stop offset="0.467" stopColor="#FF3750" />
          <stop offset="0.71" stopColor="#F5156C" />
          <stop offset="0.782" stopColor="#EB0878" />
          <stop offset="0.86" stopColor="#E50080" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_5983_4369"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.56977 10.5103) scale(20.2115)"
        >
          <stop offset="0.3" stopColor="#960E18" />
          <stop offset="0.351" stopColor="#B11927" stopOpacity="0.74" />
          <stop offset="0.435" stopColor="#DB293D" stopOpacity="0.343" />
          <stop offset="0.497" stopColor="#F5334B" stopOpacity="0.094" />
          <stop offset="0.53" stopColor="#FF3750" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_5983_4369"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12.0707 -2.24738) scale(14.6408)"
        >
          <stop offset="0.132" stopColor="#FFF44F" />
          <stop offset="0.252" stopColor="#FFDC3E" />
          <stop offset="0.506" stopColor="#FF9D12" />
          <stop offset="0.526" stopColor="#FF980E" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_5983_4369"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.31909 15.7623) scale(9.62298)"
        >
          <stop offset="0.353" stopColor="#3A8EE6" />
          <stop offset="0.472" stopColor="#5C79F0" />
          <stop offset="0.669" stopColor="#9059FF" />
          <stop offset="1" stopColor="#C139E6" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_5983_4369"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10.5479 8.77428) rotate(-13.5916) scale(5.10293 5.97426)"
        >
          <stop offset="0.206" stopColor="#9059FF" stopOpacity="0" />
          <stop offset="0.278" stopColor="#8C4FF3" stopOpacity="0.064" />
          <stop offset="0.747" stopColor="#7716A8" stopOpacity="0.45" />
          <stop offset="0.975" stopColor="#6E008B" stopOpacity="0.6" />
        </radialGradient>
        <radialGradient
          id="paint6_radial_5983_4369"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.31988 1.50353) scale(6.92394 6.92394)"
        >
          <stop stopColor="#FFE226" />
          <stop offset="0.121" stopColor="#FFDB27" />
          <stop offset="0.295" stopColor="#FFC82A" />
          <stop offset="0.502" stopColor="#FFA930" />
          <stop offset="0.732" stopColor="#FF7E37" />
          <stop offset="0.792" stopColor="#FF7139" />
        </radialGradient>
        <radialGradient
          id="paint7_radial_5983_4369"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(14.8211 -2.99852) scale(29.5418 29.5418)"
        >
          <stop offset="0.113" stopColor="#FFF44F" />
          <stop offset="0.456" stopColor="#FF980E" />
          <stop offset="0.622" stopColor="#FF5634" />
          <stop offset="0.716" stopColor="#FF3647" />
          <stop offset="0.904" stopColor="#E31587" />
        </radialGradient>
        <radialGradient
          id="paint8_radial_5983_4369"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12.3682 -1.35929) rotate(83.976) scale(21.6487 14.2078)"
        >
          <stop stopColor="#FFF44F" />
          <stop offset="0.06" stopColor="#FFE847" />
          <stop offset="0.168" stopColor="#FFC830" />
          <stop offset="0.304" stopColor="#FF980E" />
          <stop offset="0.356" stopColor="#FF8B16" />
          <stop offset="0.455" stopColor="#FF672A" />
          <stop offset="0.57" stopColor="#FF3647" />
          <stop offset="0.737" stopColor="#E31587" />
        </radialGradient>
        <radialGradient
          id="paint9_radial_5983_4369"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.31963 4.00834) scale(18.4405 18.4405)"
        >
          <stop offset="0.137" stopColor="#FFF44F" />
          <stop offset="0.48" stopColor="#FF980E" />
          <stop offset="0.592" stopColor="#FF5634" />
          <stop offset="0.655" stopColor="#FF3647" />
          <stop offset="0.904" stopColor="#E31587" />
        </radialGradient>
        <radialGradient
          id="paint10_radial_5983_4369"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(14.0726 5.0086) scale(20.184)"
        >
          <stop offset="0.094" stopColor="#FFF44F" />
          <stop offset="0.231" stopColor="#FFE141" />
          <stop offset="0.509" stopColor="#FFAF1E" />
          <stop offset="0.626" stopColor="#FF980E" />
        </radialGradient>
        <linearGradient
          id="paint11_linear_5983_4369"
          x1="17.5013"
          y1="3.01933"
          x2="3.80853"
          y2="16.7146"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.167" stopColor="#FFF44F" stopOpacity="0.8" />
          <stop offset="0.266" stopColor="#FFF44F" stopOpacity="0.634" />
          <stop offset="0.489" stopColor="#FFF44F" stopOpacity="0.217" />
          <stop offset="0.6" stopColor="#FFF44F" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_5983_4369">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
